import React from 'react';
import { isSet } from '../../../../Utils/CommonFunctions';
// import elementsProperties from './elementsProperties';


const ScmName = (props)=>{
    const {elementData} = props;
    let scmNameValue = (isSet(elementData.data,null)!==null)?elementData.data:'';
     

    return(
        <div className="w-100">
            <div className="input-group mb-3">  
                <div className="input-group-prepend">
                    <span className="input-group-text text-truncate" style={{minWidth:'100px'}}>Name</span>
                </div>              
                <input type="text" className="form-control" value={scmNameValue} readOnly  />                
            </div>
                      
        </div>
    )
}


export default ScmName;